import { useMutation } from '@tanstack/react-query'
import axios from 'axios'
import { useEffect, useRef } from 'react'
import { toast } from 'react-toastify'

import {
  FileToUpload,
  UploadQueue,
} from './use-create-diagnosis/manager/upload-queue'

interface UploadQueueProps {
  onUploadProgressByInput: (
    inputType: string,
    progress: { progress?: number; length?: number },
  ) => void
  onFileDone: (index: number) => void
}

interface UploadQueuePayload {
  diagnosisId: string
  filesToUpload: FileToUpload[]
}

export function useUploadQueue({
  onUploadProgressByInput,
  onFileDone,
}: UploadQueueProps) {
  const abortController = useRef(new AbortController())

  const mutation = useMutation({
    mutationFn: async ({ diagnosisId, filesToUpload }: UploadQueuePayload) => {
      const uploadQueue = new UploadQueue({
        abortController: abortController.current,
        onUploadProgressByInput: onUploadProgressByInput,
        onFileDone: onFileDone,
      })

      await uploadQueue.execute(diagnosisId, filesToUpload)
    },
    onError: (error: Error) => {
      if (error instanceof axios.Cancel) return

      // TODO: handle error

      toast.error(
        `Ocorreu um erro ao fazer o upload dos arquivos. Tente novamente. [${error.message}]`,
      )
    },
  })

  useEffect(() => {
    return () => {
      abortController.current.abort()
    }
  }, [])

  return mutation
}
